
/* injects from baggage-loader */

'use strict';

import AccountProfileComponent from './account.profile.component';

const AccountProfilePageModule = angular.module('account-profile-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.profile', {
        url: '/profile',
        component: 'accountProfile',
        // Requires valid login to visit
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('accountProfile', new AccountProfileComponent());

export default AccountProfilePageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/profile/account.profile.module.js